import {NgModule}      from '@angular/core';
import {CommonModule}  from '@angular/common';

import {BrowserModule} from '@angular/platform-browser';

import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {Router, NavigationStart, NavigationEnd, RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';


import {PortfolioModule} from './portfolio/portfolio.module';
import {StructureComponent} from './structure.component';
import {HiringModule} from "./hiring/hiring.module";
import {HiringrequestModule} from "./hiringrequest/hiringrequest.module";
import {SiteconfigModule} from "./siteconfig/siteconfig.module";
import {ContactusModule} from "./contactus/contactus.module";
import {ClientModule} from "./client/client.module";
import {BlogModule} from "./blog/blog.module";
import {BlogcategoryModule} from "./blogcategory/blogcategory.module";
import { NewprojectModule } from "./newproject/newproject.module";
import { TraineeModule } from "./trainee/trainee.module";
import { BloguserModule } from './bloguser/bloguser.module';
import { BlogpostModule } from './blogpost/blogpost.module';
import { BlogUserdetailsModule } from './bloguserdetails/bloguserdetails.module';
import { BlogpostdetailModule } from './blogpostdetail/blogpostdetail.module';
import { BlogverifyModule } from './blogverify/blogverify.module';


import { AdminCrashreportModule } from './admincrashreport/admincrashreport.module';



declare var NProgress: any;

@NgModule({

    declarations: [
        StructureComponent,
        
       
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        RouterModule,
        CommonModule,
        RouterModule,
        PortfolioModule,
        HiringModule,
        BlogModule,
        BlogcategoryModule,
        HiringrequestModule,
        ContactusModule,
        ClientModule,
        SiteconfigModule,
        NewprojectModule,
        TraineeModule,
        BloguserModule,
        BlogpostModule,
        BlogUserdetailsModule,
        BlogpostdetailModule,
        BlogverifyModule,
        AdminCrashreportModule,
        NgbModule.forRoot()
    ],
    providers: [],
    bootstrap: [StructureComponent]
})
export class StructureModule {

    constructor(private router: Router) {
        router.events.subscribe((event) => {

            if (event instanceof NavigationStart) {
                NProgress.start();
            }

            if (event instanceof NavigationEnd) {
                setTimeout(function () {
                    NProgress.done();
                }, 200);
            }

        });
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/structure.module.ts